import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import FastImage from 'utils/packages/rnFastImage';
import Animated, { useAnimatedScrollHandler, useSharedValue, } from 'react-native-reanimated';
import { Button, CARD_VIEW_BORDER_RADIUS, CardView, NavigationHeader, SCROLL_INDICATOR_INSETS, rem, } from 'design-system';
import BottomPanel from 'design-system/BottomPanel';
import { NavigationHeaderRightTextButton } from 'design-system/NavigationHeaderRightTextButton';
import InfoCardWithIndex from 'design-system/InfoCardWithIndex';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import Text from 'design-system/Text';
import { selectDefaultFreeTrialDays } from 'features/premium/selectors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils';
import { isWeb } from '../../../constants';
const InviteIntroView = ({ getPremiumCredit, givePremiumTrialDays, currency, onPressInvite, onOpenTerms, onPressTrack, }) => {
    const scrollY = useSharedValue(0);
    const onScrollHandler = useAnimatedScrollHandler((event) => {
        scrollY.value = event.contentOffset.y;
    }, []);
    // On web this sits in the browser-wide stack header, where a text button
    // lines up with the other web headers (e.g. Help).
    const rightContent = useMemo(() => isWeb ? (<NavigationHeaderRightTextButton text="Track invites" onPress={onPressTrack}/>) : (<Button title="Track invites" brandReversed square small onPress={onPressTrack}/>), [onPressTrack]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const defaultFreeTrialDays = useAppSelector(selectDefaultFreeTrialDays);
    return (<View style={styles.container}>
      <NavigationHeader scrollY={scrollY} rightContent={rightContent}/>
      <Animated.ScrollView onScroll={onScrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={paddingHorizontalStyle}>
        <ScreenInfoHeader preTitle="Invite & earn" title={`Give ${givePremiumTrialDays} days trial, get ${formatAmount(getPremiumCredit, currency)}!`}/>
        <CardView noMarginTop>
          <FastImage source={require('../img/gift.png')} style={styles.giftImage} resizeMode="cover"/>
          <InfoCardWithIndex withTimeline index={1} title="Send an invite" subTitle="Share a link with family and friends and make them signup to Emma" style={styles.indexItem}/>
          <InfoCardWithIndex withTimeline index={2} title={`Your friend gets ${givePremiumTrialDays} day free-trial`} subTitle={`This is more than the standard ${defaultFreeTrialDays}-day trial and it’s available across all plans`} style={styles.indexItem}/>
          <InfoCardWithIndex withTimeline index={3} title={`You get ${formatAmount(getPremiumCredit, currency)} in Emma credits`} subTitle="We’ll apply this discount to your next subscription invoice" style={styles.indexItem}/>
          <InfoCardWithIndex withTimeline isLast index={4} title="Enjoy our premium plans at a discount" subTitle="The more you invite, the less you pay" style={styles.indexItem}/>
        </CardView>
      </Animated.ScrollView>
      <BottomPanel>
        <Text TextThin-14 centered Secondary style={styles.termsText}>
          <Text TextThin-14 Primary onPress={onOpenTerms} suppressHighlighting>
            T&Cs
          </Text>{' '}
          apply
        </Text>
        <Button title="Invite friends" onPress={onPressInvite} brand/>
      </BottomPanel>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    termsText: {
        marginBottom: rem(16),
    },
    indexItem: {
        paddingHorizontal: rem(16),
    },
    giftImage: {
        height: rem(135),
        marginBottom: rem(16),
        borderTopLeftRadius: CARD_VIEW_BORDER_RADIUS,
        borderTopRightRadius: CARD_VIEW_BORDER_RADIUS,
    },
});
export default InviteIntroView;
